import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ROLE_OPTIONS = [
  { value: 'super_admin', label: 'Super Admin' },
  { value: 'admin', label: 'Admin/Owner' },
  { value: 'center_manager', label: 'Center Manager Sales' },
  { value: 'center_manager_ops', label: 'Center Manager Ops' },
  { value: 'sales', label: 'Sales' },
  { value: 'operations', label: 'Operations' },
];

const EditUserModal = ({ user, onClose, onSave, loading }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    role: 'sales',
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      setFormData({
        fullName: user?.fullName || '',
        phone: user?.phone || '',
        role: user?.role || 'sales',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError(null);
    if (!formData?.fullName?.trim()) {
      setError('Full name is required');
      return;
    }
    try {
      await onSave?.(user?.id, {
        fullName: formData?.fullName?.trim(),
        phone: formData?.phone?.trim() || null,
        role: formData?.role,
      });
    } catch (err) {
      setError(err?.message || 'Failed to update user');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <div>
            <h2 className="text-lg font-bold text-gray-900">Edit User</h2>
            <p className="text-sm text-gray-500 mt-0.5">{user?.email}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <Icon name="X" size={22} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center gap-2">
              <Icon name="AlertCircle" size={16} className="text-red-500 flex-shrink-0" />
              <p className="text-sm text-red-700">{error}</p>
            </div>
          )}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
            <Input
              type="text"
              name="fullName"
              value={formData?.fullName}
              onChange={handleChange}
              placeholder="John Doe"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
            <Input
              type="tel"
              name="phone"
              value={formData?.phone}
              onChange={handleChange}
              placeholder="+91 98765 43210"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Global Role *</label>
            <Select name="role" value={formData?.role} onChange={handleChange} required>
              {ROLE_OPTIONS?.map((opt) => (
                <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
              ))}
            </Select>
          </div>
          <div className="flex justify-end gap-3 pt-2">
            <Button type="button" variant="secondary" onClick={onClose} disabled={loading}>Cancel</Button>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserModal;
